import IssuerContributionAnalysis from "../../tables/issuerContributionAnalysis";
import SectorContributionAnalysis from "../../tables/sectorContributionAnalysis";
import TopHoldingsCorrelation from "./topHoldingsCorrelation";

const correlationMatrixData = [
    ["Aditya Birla Sun Life PSU Equity Fund ", 1.00, 0.50, 0.29, 0.06, 0.94, 0.59, 0.41, 0.03, 0.12, -0.07],
    ["ICICI Prudential BHARAT 22 FOF", 0.50, 1.00, -0.16, 0.11, 0.48, 0.47, 0.24, 0.04, 0.09, -0.32],
    ["SBI PSU Direct Plan Growth", 0.29, -0.16, 1.00, 0.43, 0.30, 0.13, 0.26, 0.03, 0.10, 0.25],
    ["Motilal Oswal Midcap Fund Direct Growth", 0.06, 0.11, 0.43, 1.00, 0.06, 0.11, 0.05, 0.02, 0.06, 0.03],
    ["Nippon India Power & Infra Fund Direct Growth", 0.94, 0.48, 0.30, 0.06, 1.00, 0.58, 0.41, 0.03, 0.12, -0.05],
    ["LIC MF Infrastructure Fund Direct Growth", 0.59, 0.47, 0.13, 0.11, 0.58, 1.00, 0.32, 0.04, 0.11, 0.15],
    ["IDBI Small Cap Fund Direct Growth", 0.41, 0.24, 0.26, 0.05, 0.41, 0.32, 1.00, 0.03, 0.10, 0.10],
    ["Franklin Build India Direct Fund Growth", 0.03, 0.04, 0.03, 0.02, 0.03, 0.04, 0.03, 1.00, 0.04, 0.01],
    ["Bandhan Infrastructure Fund Direct Plan Growth", 0.12, 0.09, 0.10, 0.06, 0.12, 0.11, 0.10, 0.04, 1.00, 0.50],
    ["Axis Small Cap Fund Direct Growth", -0.07, -0.32, 0.25, 0.03, -0.05, 0.15, 0.10, 0.01, 0.50, 1.00],
    ["", "Aditya Birla Sun Life PSU Equity Fund", "ICICI Prudential BHARAT 22 FOF", "SBI PSU Direct Plan Growth", "Motilal Oswal Midcap Fund Direct Growth", "Nippon India Power & Infra Fund Direct Growth", "LIC MF Infrastructure Fund Direct Growth", "IDBI Small Cap Fund Direct Growth", "Franklin Build India Direct Fund Growth", "Bandhan Infrastructure Fund Direct Plan Growth", "Axis Small Cap Fund Direct Growth"]
]

const sectorContributionAnalysisData = [
    {
        id: 1,
        sector: "Banking",
        portfolioWeight: 20,
        portfolioReturns: 1,
        cumulativeWeight: 20
    },
    {
        id: 2,
        sector: "BroadCasting",
        portfolioWeight: 18,
        portfolioReturns: 2,
        cumulativeWeight: 38
    },
    {
        id: 3,
        sector: "Chemicals",
        portfolioWeight: 15,
        portfolioReturns: 0,
        cumulativeWeight: 53
    },
    {
        id: 4,
        sector: "Electronics",
        portfolioWeight: 12,
        portfolioReturns: -6,
        cumulativeWeight: 65
    },
    {
        id: 5,
        sector: "E-Retail / E-Commerce",
        portfolioWeight: 10,
        portfolioReturns: 1,
        cumulativeWeight: 75
    },
    {
        id: 6,
        sector: "Automobile",
        portfolioWeight: 8,
        portfolioReturns: 1,
        cumulativeWeight: 83
    },
    {
        id: 7,
        sector: "Cement",
        portfolioWeight: 7,
        portfolioReturns: 2,
        cumulativeWeight: 90
    },
    {
        id: 8,
        sector: "Diversified Commercials",
        portfolioWeight: 5,
        portfolioReturns: 0,
        cumulativeWeight: 95
    },
    {
        id: 9,
        sector: "Engineering & Construction",
        portfolioWeight: 3,
        portfolioReturns: 12,
        cumulativeWeight: 98
    },
    {
        id: 10,
        sector: "Others",
        portfolioWeight: 2,
        portfolioReturns: 2,
        cumulativeWeight: 100
    }
]

const issuerContributionAnalysisData = [
    {
        id: 1,
        issuer: "Axis AMC",
        portfolioWeight: 20,
        portfolioReturns: 1,
        cumulativeWeight: 20
    },
    {
        id: 2,
        issuer: "ICICI Prudential AMC",
        portfolioWeight: 18,
        portfolioReturns: 2,
        cumulativeWeight: 38
    },
    {
        id: 3,
        issuer: "HDFC AMC",
        portfolioWeight: 15,
        portfolioReturns: 0,
        cumulativeWeight: 53
    },
    {
        id: 4,
        issuer: "Kotak Mahindra AMC",
        portfolioWeight: 12,
        portfolioReturns: -6,
        cumulativeWeight: 65
    },
    {
        id: 5,
        issuer: "Inveso AMC",
        portfolioWeight: 10,
        portfolioReturns: 1,
        cumulativeWeight: 75
    },
    {
        id: 6,
        issuer: "Nippon Life AMC",
        portfolioWeight: 8,
        portfolioReturns: 1,
        cumulativeWeight: 83
    },
    {
        id: 7,
        issuer: "Aditya Birla Sun Life AMC",
        portfolioWeight: 7,
        portfolioReturns: 2,
        cumulativeWeight: 90
    },
    {
        id: 8,
        issuer: "Canara Robeco AMC",
        portfolioWeight: 5,
        portfolioReturns: 0,
        cumulativeWeight: 95
    },
    {
        id: 9,
        issuer: "Edelweiss AMC",
        portfolioWeight: 3,
        portfolioReturns: 12,
        cumulativeWeight: 98
    },
    {
        id: 10,
        issuer: "Others",
        portfolioWeight: 2,
        portfolioReturns: 2,
        cumulativeWeight: 100
    }
]


export default function PrescriptiveAnalysis(): JSX.Element {
    return (
        <>
            <TopHoldingsCorrelation data={correlationMatrixData} />
            <SectorContributionAnalysis
                tableOneData={sectorContributionAnalysisData.slice(0, 5)}
                tableTwoData={sectorContributionAnalysisData.slice(5)}
            />
            <IssuerContributionAnalysis
                tableOneData={issuerContributionAnalysisData.slice(0, 5)}
                tableTwoData={issuerContributionAnalysisData.slice(5)}
            />
        </>
    )
}